import CheckmarkIconOrange from "@/assets/images/icons/checkmark_icon_orange.svg";
import { BRAND_COLORS } from "@/lib/brandColors";
import { Image as ExpoImage } from "expo-image";
import React from "react";
import { Image, XStack, YStack } from "tamagui";

type ListRowThumbnailColumnProps = {
  thumbnailUri?: string | null;
  aspectRatio: number;
  /** 0–100 */
  progress: number;
  /** Fixed height (catalog rows). Omit for responsive 3/4/6 (lesson rows). */
  progressBarHeight?: number;
  showCheckmark?: boolean;
  imageEngine?: "expo" | "tamagui";
  recyclingKey?: string;
  /** Catalog rows show a neutral block when thumbnail is missing; lesson rows do not. */
  showEmptyPlaceholder?: boolean;
};

export function ListRowThumbnailColumn({
  thumbnailUri,
  aspectRatio,
  progress,
  progressBarHeight,
  showCheckmark = false,
  imageEngine = "tamagui",
  recyclingKey,
  showEmptyPlaceholder = imageEngine === "expo",
}: ListRowThumbnailColumnProps) {
  const clampedProgress = Math.min(100, Math.max(0, progress));

  return (
    <YStack
      w={160}
      $gtSm={{ w: 220 }}
      $gtMd={{ w: 267 }}
      bg="#eee"
      overflow="hidden"
      borderTopRightRadius={10}
      borderBottomRightRadius={10}
      position="relative"
      flexShrink={0}
    >
      {thumbnailUri ? (
        imageEngine === "expo" ? (
          <ExpoImage
            source={{ uri: thumbnailUri }}
            style={{
              width: "100%",
              aspectRatio,
              backgroundColor: "#eee",
            }}
            contentFit="cover"
            recyclingKey={recyclingKey ?? thumbnailUri}
          />
        ) : (
          <Image
            source={{ uri: thumbnailUri }}
            w="100%"
            aspectRatio={aspectRatio}
            resizeMethod="scale"
          />
        )
      ) : showEmptyPlaceholder ? (
        <YStack w="100%" aspectRatio={aspectRatio} bg="#E8E4DF" />
      ) : null}
      {showCheckmark ? (
        <YStack position="absolute" top={9} right={9} zIndex={1}>
          <CheckmarkIconOrange width={16} height={16} />
        </YStack>
      ) : null}
      <XStack
        {...(progressBarHeight != null
          ? { h: progressBarHeight }
          : { h: 3, $gtSm: { h: 4 }, $gtMd: { h: 6 } })}
        backgroundColor={BRAND_COLORS.border}
        overflow="hidden"
      >
        <YStack
          h="100%"
          backgroundColor="$accent"
          borderRadius={30}
          w={`${clampedProgress}%`}
        />
      </XStack>
    </YStack>
  );
}
